import React, { useMemo, useState, useEffect } from "react";
import SurveyQuestion from "./SurveyQuestion";
import BlockCompletePopup from "./PopupAnimation";

export default function SurveyBlock({ block, responses, onItemChange }) {
  const [disableClicks, setDisableClicks] = useState(false);
  const [showBlockPopup, setShowBlockPopup] = useState(false);
  const [popupShown, setPopupShown] = useState(false);

  const items = block.items; 

  // Detect block completion
  useEffect(() => {
    const allAnswered = items.every((item) => {
      const v = responses[item.itemid];
      return v !== undefined && v !== null && v !== "";
    });

    if (allAnswered && !showBlockPopup && !popupShown) {
      setShowBlockPopup(true);
      setPopupShown(true);
    }
    if (showBlockPopup && popupShown) {
      const t = setTimeout(() => {
        setShowBlockPopup(false);
      }, 1500);

      return () => clearTimeout(t);
    }
    
  }, [responses, items, showBlockPopup, popupShown]);

  return (
    <section className="mb-6 rounded-2xl bg-white p-5 shadow-sm">
      {block.blocktext && <p className="mb-4 text-lg font-light text-slate-800">{block.blocktext}</p>}

      <div className="space-y-4">
        {items.map((item) => (
          <SurveyQuestion
            key={item.itemid}
            item={item}
            value={responses[item.itemid]}
            onChange={(value) => onItemChange(item, value)}
            disableClicks={disableClicks}
            setDisableClicks={setDisableClicks}
          />
        ))}
      </div>

      <BlockCompletePopup visible={showBlockPopup} onClose={() => setShowBlockPopup(false)} />
    </section>
  );
}
